export default __webpack_public_path__ + "static/media/118.09851aab.jpg";